import React from 'react';
import { useTranslation } from 'react-i18next';
import { isMobileDevice } from '@panel/commons/helpers/device';
import { useSelector } from 'react-redux';
import { Item } from './item';
import { CardShowMore, ShowMore } from './styles';
import { getMultimediaState } from '../../../../ducks/step2';
import LoadSpinner from './loadspinner';

function ItemList({
  items,
  onUpdate,
  onDelete,
  onMove,
  onError,
  mainMarker,
  mainMarkerTitle,
  editablePlaceholder,
  hasMain,
  onMainImageChange,
  onStatusChange,
  keysErrors,
  setCollapse,
  collapse,
  photoType
}) {
  const { processing: uploadInProgress } = useSelector(getMultimediaState);
  const { t } = useTranslation();
  const isMobile = isMobileDevice();

  // Indice y Tamaño para mostrar la card de "ver mas fotos"
  const indexCardShow = isMobile ? 2 : 4;
  const lengthCardShow = isMobile ? 3 : 5;

  const updateUrl = (id, attrs) => {
    const itemToUpdate = items.find(i => i.id === id);
    onUpdate({ ...itemToUpdate, ...attrs });
  };

  const rotateItem = id => {
    const itemToRotate = items.find(i => i.id === id);
    let { angle } = itemToRotate;
    if (angle === 270) {
      angle = 0;
    } else {
      angle += 90;
    }
    onUpdate({ ...itemToRotate, angle });
  };

  const onTitle = (id, title) => {
    const item = items.find(i => i.id === id);
    onUpdate({ ...item, title });
  };

  const onStatusHandler = (item, status) => {
    if (onStatusChange && typeof onStatusChange === 'function' && item.id && !item.id_multimedia) {
      onStatusChange({ key: item.id, status });
    }
  };

  const boxes = items.sort().map((item, idx) => {
    return (
      <React.Fragment key={`${item.id}-item`}>
        {items.length > lengthCardShow && idx === indexCardShow && collapse.isCollapsed && (
          <CardShowMore key={`${item.id}-showmore`}>
            <div>+ {items.length - indexCardShow}</div>
            <ShowMore onClick={() => setCollapse({ isCollapsed: !collapse.isCollapsed, keepOpen: !collapse.keepOpen })}>
              {photoType === 'picture'
                ? t(`publisher.step2.module1.picture.btn.more`)
                : t(`publisher.step2.module2.plans.btn.more`)}
            </ShowMore>
            {uploadInProgress && <LoadSpinner width='70px' height='70px' />}
          </CardShowMore>
        )}
        <Item
          data-repa={`step2-${item.multimediaType === 'IMAGE' ? 'images' : 'plans'}-itemlist-item-${item.order}`}
          item={item}
          onDelete={onDelete}
          onTitle={onTitle}
          onRotate={rotateItem}
          onUrl={updateUrl}
          index={idx}
          moveItem={onMove}
          onError={onError}
          mainMarker={mainMarker}
          mainMarkerTitle={mainMarkerTitle}
          editablePlaceholder={editablePlaceholder}
          hasMain={hasMain}
          onStatusChange={onStatusHandler}
          onMainSelect={() => onMainImageChange(idx, 0)}
          keysErrors={keysErrors}
        />
      </React.Fragment>
    );
  });

  return <>{boxes}</>;
}

export { ItemList };
